// src/utils/getLocalIPv4s.ts
export async function getLocalIPv4s(timeout = 1200): Promise<string[]> {
  const ips = new Set<string>();
  // @ts-ignore
  const RTCPeerConnectionClass = window.RTCPeerConnection || (window as any).webkitRTCPeerConnection;
  if (!RTCPeerConnectionClass) return [];

  const pc = new RTCPeerConnectionClass({ iceServers: [] });
  pc.createDataChannel("");

  return new Promise((resolve) => {
    const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/g;
    const timer = setTimeout(() => {
      pc.close();
      resolve(Array.from(ips));
    }, timeout);

    pc.onicecandidate = (event: RTCPeerConnectionIceEvent) => {
      if (!event.candidate) return;
      const result = event.candidate.candidate.match(ipRegex);
      if (result) {
        result.forEach((ip) => {
          // chỉ lấy IPv4 private range
          if (ip.startsWith("192.") || ip.startsWith("10.") || ip.startsWith("172.")) {
            ips.add(ip);
          }
        });
      }
    };

    pc.createOffer()
      .then((offer) => pc.setLocalDescription(offer))
      .catch(() => {
        clearTimeout(timer);
        resolve([]);
      });
  });
}
